/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {JsonApiResource} from "@irian-ro/abstract-resource";
import {SignupFirstContactDto, SignupFirstContactMeta} from "@well/domain";
import {
  CompanyRegistrationResourceService, InitialRoleAssignmentResourceService,
  SignupFirstContactResourceService
} from "@well/resource-services";
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable()
export class FirstContactService{

  constructor(private signupFirstContactResourceService: SignupFirstContactResourceService,
              private companyRegistrationResourceService: CompanyRegistrationResourceService,
              private initialRoleAssignmentResourceService: InitialRoleAssignmentResourceService) {
  }

  getTemplate(): Observable<JsonApiResource<SignupFirstContactDto, SignupFirstContactMeta>>{
    return this.signupFirstContactResourceService.getTemplate();
  }

  saveFirstContact(signupFirstContact: SignupFirstContactDto){
    return this.signupFirstContactResourceService.save(signupFirstContact);
  }

  getCurrentCompanyRegistration(){
    return this.companyRegistrationResourceService.getMyCompanyProfile();
  }

  assignInitialRoleToCurrentUser(companyType: CompanyType){
    return this.initialRoleAssignmentResourceService.assignInitialRoleToCurrentUser(companyType);
  }

}
